import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#3D5A3E',
                secondary: '#6B7F5E',
                accent: '#C5A55A',
                error: '#B85C4A',
                info: '#8B9F76',
                success: '#6B7F5E',
                warning: '#C5A55A',
                background: '#FDF8F0',
                surface: '#F5EDE0',
            }
        },
        options: {
            customProperties: true,
        },
    },
    icons: {
        iconfont: 'mdi',
    },
});
